import {
    ROLE_PARTNER_PHYSICIAN,
    ROLE_PARTNER_PHYSICIAN_REMOTE, ROLE_PARTNER_SCAN_PHYSICIAN, ROLE_TREATING_PHYSICIAN,
    ROLE_TREATING_PHYSICIAN_REMOTE,
} from '../../security/state/auth/const'

const TYPE_INTERNAL = 'internal'
const TYPE_EXTERNAL = 'external'
const TYPE_PARTNER = 'partner'

function createInternalPhysiciansList (userList, selectedUserId) {
    const filteredList = filterInternalPhysicians(userList, selectedUserId)
    return buildReassignInternalPhysicianList(filteredList)
}

function createExternalPhysiciansList (userList, selectedUserId) {
    const filteredList = filterExternalPhysicians(userList, selectedUserId)
    return buildReassignExternalPhysicianList(filteredList)
}

function findPhysician (physiciansList, physicianId) {
    return physiciansList.find((physician) => {
        return physicianId === physician.value
    })
}

function createPartnerPhysiciansList (partnerPhysicians) {
    return partnerPhysicians.map((physician) => {
        return {
            value: physician.id,
            label: physician.displayName,
            physicianType: TYPE_PARTNER,
        }
    })
}

function filterInternalPhysicians (userList, selectedUserId) {
    return userList.filter((user) => {
        const roleList = user.roleList

        if (user.blocked) {
            return false
        }

        return user.id === selectedUserId
            || roleList.includes(ROLE_TREATING_PHYSICIAN)
            || roleList.includes(ROLE_TREATING_PHYSICIAN_REMOTE)
    })
}

function buildReassignInternalPhysicianList (userList) {
    return userList.map((user) => {
        return {
            value: user.id,
            label: `${user.firstName} ${user.lastName}`,
            physicianType: TYPE_INTERNAL,
        }
    })
}

function buildReassignExternalPhysicianList (userList) {
    return userList.map((user) => {
        return {
            value: user.id,
            label: `${user.firstName} ${user.lastName}`,
            physicianType: TYPE_EXTERNAL,
        }
    })
}


function filterExternalPhysicians (userList, selectedUserId) {
    return userList.filter((user) => {
        const roleList = user.roleList

        if (user.externalUserId === null || user.store === null || user.blocked) {
            return false
        }

        return user.id === selectedUserId
            || roleList.includes(ROLE_PARTNER_PHYSICIAN_REMOTE)
            || roleList.includes(ROLE_PARTNER_PHYSICIAN)
            || roleList.includes(ROLE_PARTNER_SCAN_PHYSICIAN)
    })
}

export default {
    createInternalPhysiciansList,
    createPartnerPhysiciansList,
    createExternalPhysiciansList,
    findPhysician,
}



// WEBPACK FOOTER //
// ./src/modules/customer/util/physician-list.js